import axios from "axios";
import { privateGetApi, buildApiUrl } from "../../utils/apiHelper";

// PRD item 3 (FR-3.9), task 3.8. Contact consent timeline + Compliance
// exports.

export const fetchConsentEvents = (contactId) => () => {
  return new Promise((resolve, reject) => {
    privateGetApi(`/contacts/${contactId}/consent-events`, {})
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result.records || []);
        } else {
          reject(response.message);
        }
      })
      .catch(reject);
  });
};

// format=pdf is a print-ready HTML page (browser "Save as PDF"), not a
// binary PDF -- this codebase has no PDF-generation library (see
// routes/contacts/index.js / lib/consent/consentProofHtml.js). Fetched as
// an authenticated blob (query-string tokens aren't read by verifyToken)
// and opened as an HTML blob URL so window.print() still works inside it.
export const openConsentProofPdf = (contactId) => () => {
  const accessToken = localStorage.getItem("accessToken");
  return axios
    .get(buildApiUrl(`/contacts/${contactId}/consent-proof`, { format: "pdf" }), {
      headers: { Authorization: `Bearer ${accessToken}` },
      responseType: "blob",
    })
    .then((res) => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "text/html" }),
      );
      window.open(url, "_blank");
    });
};

export const downloadConsentExportCsv = () => {
  const accessToken = localStorage.getItem("accessToken");
  return axios
    .get(buildApiUrl("/contacts/consent-export", { format: "csv" }), {
      headers: { Authorization: `Bearer ${accessToken}` },
      responseType: "blob",
    })
    .then((res) => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "text/csv" }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = "consent-export.csv";
      link.click();
      window.URL.revokeObjectURL(url);
    });
};
